import { Datatype } from '../../../../expressions/datatype/Datatype';
import {
  IReference,
  ReferenceType,
} from '../../../../expressions/references/IReference';
import { IReferencePath } from '../../../../expressions/references/IReferencePath';
import { IAsyncSelectWidget } from './IAsyncSelectWidget';

export function getAsyncSelectWidgetReference(
  path: IReferencePath,
  widget: IAsyncSelectWidget,
): IReference {
  return {
    type: ReferenceType.Widget,
    path,
    id: widget.id,
    code: widget.code,
    label: widget.code,
    field: {
      type: Datatype.String,
    },
  };
}
